import type { ApiResponse } from "~/types/ApiResponse";
import { ApiBaseService } from "./ApiBaseService";
import type { Brand } from "./BrandService";

export interface BrandFetchSearch {
    id?: string;
    brandId?: string;
    name?: string;
    icon?: string;
    logo_url?: string;
    website?: string;
    domain?: string;
    claimed?: boolean;
}

export default class BrandFetchService extends ApiBaseService {
    public search = (input: string) => {
        return this.request(
            this.route("api.brand-fetch.search", "brand-fetch/search"),
            {
                method: "POST",
                body: {
                    input,
                },
            },
        );
    };

    public show = (id: number) => {
        return this.request(
            this.route("api.brand-fetch.show", "brand-fetch/{brand}", {
                brand: id,
            }),
            {
                method: "GET",
            },
        );
    };

    public brands = () => {
        const update = (id: number, identifier: string, provider?: string) => {
            return this.request<ApiResponse<Brand>>(
                this.route(
                    "api.brand-fetch.brands.update}",
                    "brand-fetch/brands/{brand}",
                    {
                        brand: id,
                    },
                ),
                {
                    method: "PATCH",
                    body: {
                        identifier,
                        provider,
                    },
                },
            );
        };

        return {
            update,
        };
    };
}
